export default "__VITE_ASSET__5c0f84db__"